import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { days } from 'constants/pricing';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const DaysSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields,
  asyncErrors,
  margin,
}) => {
  const [defaultValue, setDefaultValue] = useState('');
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = days.find((days) => days?.value === value);
      if (defaultVal) {
        setDefaultValue(defaultVal);
      } else {
        setDefaultValue('');
      }
    }
  }, [value, days]) // eslint-disable-line

  return (
    <Autocomplete
      id="days"
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option?.label}
      error={handleError(name, errors, touched, asyncErrors)}
      options={days.filter((val) => omitFields.indexOf(val))}
      getOptionSelected={(option, value) => option === value || ''}
      onChange={(ev, val) => setFieldValue(name, val?.value || '')}
      onInputChange={(ev, val) => setDefaultValue(val?.label || '')}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
    />
  );
};

DaysSelect.propTypes = {
  label: PropTypes.string,
  asyncErrors: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
  omitFields: PropTypes.array,
};

DaysSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  variant: 'standard',
  label: 'Select a day',
  omitFields: [],
};

export default DaysSelect;
